// extracted by mini-css-extract-plugin
module.exports = {"selected":"_39jJP___SaveSearchSelector-module__selected","focused":"_2NUsh___SaveSearchSelector-module__focused"};